import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { sharedQuotesApi, type CreateSharedQuoteInput } from '@/services/shared-quotes';

export const useSharedQuotes = (status?: string) =>
  useQuery({
    queryKey: ['shared-quotes', status],
    queryFn: () => sharedQuotesApi.list({ status }),
  });

export const useSharedQuote = (token: string | undefined) =>
  useQuery({
    queryKey: ['shared-quote', token],
    queryFn: () => sharedQuotesApi.get(token!),
    enabled: !!token,
  });

export const useCreateSharedQuote = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateSharedQuoteInput) => sharedQuotesApi.create(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['shared-quotes'] });
    },
  });
};

export const useDeleteSharedQuote = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (token: string) => sharedQuotesApi.delete(token),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['shared-quotes'] });
    },
  });
};

export const useSendSharedQuoteEmail = () =>
  useMutation({
    mutationFn: ({
      token,
      to,
      customMessage,
    }: {
      token: string;
      to: string;
      customMessage?: string;
    }) => sharedQuotesApi.sendEmail(token, to, customMessage),
  });
